import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Row, Image, Typography, Col, Drawer, Button } from 'antd';
import Sider from 'antd/es/layout/Sider';
import logo from "../../assets/logo.png";
import { IoBrushOutline } from "react-icons/io5";
import { PiUsersThree } from 'react-icons/pi';
import { CloseOutlined } from '@ant-design/icons';

import "./style.scss";

const SideBar = (props: any) => {
    const { userRole, userStatus, isMobileMenuOpen, onMobileMenuClose } = props;
    const { Title } = Typography;
    const [current, setCurrent] = useState<any>([]);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const path = location.pathname.split('/')[1];
        setCurrent([path || 'artwork']);
    }, [location]);

    const items: any = [
        {
            key: 'artwork',
            icon: <IoBrushOutline size={18} />,
            label: 'Artwork',
            link: "/artwork",
        },
        userRole !== 'Seller' && {
            key: 'user',
            icon: <PiUsersThree style={{ height: '23px', width: '23px' }} />,
            label: 'Users',
            link: "user",
        },
    ].filter(Boolean);

    const handleMenuClick = (e: any) => {
        setCurrent([e.key]);
        if (isMobile) {
            onMobileMenuClose();
        }
    };

    const menuContent = (
        <>
            {userStatus === 'Enable' &&
                <Menu
                    mode="vertical"
                    selectedKeys={current}
                    onClick={handleMenuClick}
                    items={(items || []).map((item: any) => ({
                        key: item.key,
                        icon: <div style={{ fontSize: "20px" }}>{item.icon}</div>,
                        label: item.link ? (
                            <Link to={item.link}>{item.label}</Link>
                        ) : (
                            item.label
                        )
                    }))}
                    className="slider-menu"
                />
            }
        </>
    );

    if (isMobile) {
        return (
            <Drawer
                title={null}
                placement="left"
                onClose={onMobileMenuClose}
                open={isMobileMenuOpen}
                width={280}
                className="mobile-sidebar-drawer"
                bodyStyle={{ padding: 0 }}
            >
                <div className="mobile-drawer-header-row">
                    <div className="mobile-drawer-logo">
                        <Image width={32} src={logo} preview={false} />
                        <span className="mobile-drawer-title">NeXPyn</span>
                    </div>
                    <Button
                        type="text"
                        icon={<CloseOutlined style={{ fontSize: 22 }} />}
                        onClick={onMobileMenuClose}
                        className="mobile-drawer-close-btn"
                        aria-label="Close menu"
                    />
                </div>
                <div className="sider-container mobile-sider">
                    {menuContent}
                </div>
            </Drawer>
        );
    }

    return (
        <Sider
            style={{ background: '#F8F9FAFF' }}
            width={228}
            className='sider-container desktop-sider'
        >
            <Row style={{ padding: '10px 10px 10px 20px' }} gutter={8} className="logo-section">
                <Col>
                    <Image width={35} src={logo} preview={false} />
                </Col>
                <Col>
                    <Title className='logo-heading'>
                        NeXPyn
                    </Title>
                </Col>
            </Row>
            {menuContent}
        </Sider>
    );
};

export default SideBar;